{
  "title": "Utilisateurs et rôles",
  "subtitle": "Qui peut utiliser l'application, ce que chacun peut faire, et dans quels emplacements.",
  "newUser": "Nouvel utilisateur",
  "tabs": {
    "people": "Personnes · {{count}}",
    "roles": "Rôles · {{count}}"
  },
  "list": {
    "title": "Personnes · {{active}} actives, {{deactivated}} désactivées",
    "neverDeleted": "Les utilisateurs ne sont jamais supprimés, leur historique reste lisible",
    "person": "Personne",
    "workplaces": "Peut travailler à",
    "lastSignIn": "Dernière connexion",
    "status": "Statut",
    "resetPassword": "Réinitialiser le mot de passe",
    "allLocations": "Tous les emplacements",
    "allLocationsReadOnly": "Tous les emplacements, en lecture",
    "defaultMark": "(par défaut)",
    "never": "Jamais",
    "failedToday_one": "{{count}} échec aujourd'hui",
    "failedToday_many": "{{count}} échecs aujourd'hui",
    "failedToday_other": "{{count}} échecs aujourd'hui"
  },
  "status": {
    "active": "Actif",
    "deactivated": "Désactivé",
    "locked": "Bloqué"
  },
  "fields": {
    "fullName": "Nom complet",
    "username": "Nom d'utilisateur",
    "email": "Email",
    "role": "Rôle",
    "language": "Langue",
    "locationAccess": "Où la personne peut travailler",
    "locations": "Emplacements",
    "defaultLocation": "Emplacement par défaut",
    "password": "Mot de passe"
  },
  "roleHints": {
    "admin": "Tout, y compris les utilisateurs, la configuration, le profil de l'entreprise et les sauvegardes.",
    "manager": "Tout le travail sur le stock dans tous les emplacements, valide corrections et inventaires, voit les coûts et les rapports.",
    "storekeeper": "Opérations quotidiennes sur les emplacements attribués uniquement. Pas de prix de revient.",
    "cashier": "Vend au comptoir de son magasin : ouvre et ferme sa session de caisse, encaisse. Sans prix de revient.",
    "viewer": "Consultation du stock, des tableaux de bord et des rapports."
  },
  "access": {
    "all": {
      "title": "Tous les emplacements",
      "text": "Peut travailler dans chaque site, actuel et futur."
    },
    "assigned": {
      "title": "Emplacements attribués uniquement",
      "text": "Voit et utilise seulement les emplacements choisis ci-dessous."
    },
    "noLocations": "Aucun emplacement n'existe encore. Créez d'abord vos sites dans Emplacements, puis attribuez-les ici.",
    "none": "Aucun",
    "full": "Complet",
    "read": "Lecture",
    "readAll": "Tout lire",
    "own": "les siens",
    "ownActivity": "Ses actions et ses emplacements",
    "stockMovements": "Mouvements de stock",
    "setUpAndReceive": "Configurer et recevoir",
    "receive": "Recevoir",
    "quantitiesOnly": "Quantités seulement",
    "modules": {
      "company": "Profil de l'entreprise",
      "configuration": "Configuration",
      "users": "Utilisateurs et rôles",
      "products": "Produits",
      "locations": "Emplacements",
      "stock": "Entrées et sorties",
      "transfers": "Transferts",
      "counts": "Inventaires",
      "customers": "Clients",
      "orders": "Commandes",
      "payments": "Paiements",
      "registers": "Caisses",
      "shifts": "Sessions de caisse",
      "pos": "Point de vente",
      "activity": "Journal d'activité",
      "alerts": "Alertes",
      "analytics": "Tableau de bord et rapports",
      "dataTools": "Outils de données",
      "special": "Permissions spéciales",
      "suppliers": "Fournisseurs",
      "supplierPayments": "Paiements fournisseurs",
      "promotions": "Promotions"
    },
    "actions": {
      "default": {
        "view": "Lecture",
        "create": "Créer",
        "edit": "Modifier",
        "validate": "Valider",
        "viewMovements": "Mouvements de stock",
        "import": "Importer",
        "export": "Exporter",
        "backup": "Sauvegarder et restaurer"
      },
      "transfers": {
        "create": "Envoyer",
        "validate": "Réceptionner"
      },
      "counts": {
        "create": "Compter"
      },
      "orders": {
        "fulfill": "Préparer et remettre",
        "cancel": "Annuler"
      },
      "payments": {
        "record": "Encaisser",
        "refund": "Rembourser"
      },
      "registers": {
        "manage": "Paramétrer"
      },
      "shifts": {
        "open": "Ouvrir",
        "close": "Fermer",
        "viewAll": "Toutes les sessions"
      },
      "pos": {
        "sell": "Vendre",
        "sellWholesale": "Vendre en gros"
      },
      "activity": {
        "view": "Tout lire"
      },
      "alerts": {
        "view": "Recevoir",
        "edit": "Configurer"
      },
      "promotions": {
        "manage": "Gérer"
      },
      "supplierPayments": {
        "record": "Enregistrer",
        "cancel": "Annuler"
      }
    }
  },
  "form": {
    "createTitle": "Nouvel utilisateur",
    "createSubtitle": "La personne choisira son propre mot de passe à la première connexion.",
    "editTitle": "Modifier {{name}}",
    "create": "Créer l'utilisateur",
    "saved": "{{name}} enregistré",
    "created": "{{name}} créé",
    "deactivate": "Désactiver",
    "reactivate": "Réactiver",
    "deactivated": "{{name}} désactivé et déconnecté",
    "reactivated": "{{name}} réactivé",
    "usernameFixed": "Le nom d'utilisateur ne change jamais : il identifie la personne dans l'historique.",
    "usernameHint": "Lettres minuscules, chiffres, points et tirets.",
    "emailHint": "Utilisé pour les emails « mot de passe oublié ».",
    "defaultLocationHint": "Pré-rempli dans ses opérations.",
    "noDefault": "Aucun",
    "passwordGenerate": {
      "title": "Générer un mot de passe temporaire",
      "text": "Affiché une seule fois, à remettre à la personne."
    },
    "passwordSet": {
      "title": "Saisir un mot de passe",
      "text": "La personne le changera quand même à la première connexion."
    },
    "confirmDeactivateTitle": "Désactiver {{name}} ?",
    "confirmDeactivateText": "La personne est déconnectée immédiatement et ne peut plus se connecter. Son historique reste, et vous pourrez la réactiver plus tard.",
    "signIns": "Historique des connexions"
  },
  "temporary": {
    "title": "Mot de passe temporaire de {{name}}",
    "text": "Remettez-le en main propre. Il n'est affiché que maintenant ; la personne choisira son propre mot de passe à la première connexion.",
    "copy": "Copier",
    "copied": "Copié"
  },
  "reset": {
    "title": "Réinitialiser le mot de passe de {{name}} ?",
    "text": "Un mot de passe temporaire est généré et toutes les sessions ouvertes de cette personne sont fermées. Elle choisira un nouveau mot de passe à la prochaine connexion. Un éventuel blocage après échecs est aussi levé.",
    "confirm": "Réinitialiser"
  },
  "matrix": {
    "title": "Ce que chaque rôle peut faire",
    "subtitle": "Les magasiniers et les caissiers ne voient que les sites qui leur sont attribués",
    "edit": "Modifier les permissions",
    "area": "Espace",
    "editTitle": "Modifier les permissions",
    "editSubtitle": "Les changements s'appliquent tout de suite à chaque personne ayant ce rôle, et sont enregistrés.",
    "adminLocked": "Les administrateurs ont toujours toutes les permissions, pour que personne ne perde l'accès à la gestion des utilisateurs.",
    "saved": "Permissions enregistrées"
  },
  "special": {
    "title": "Permissions spéciales",
    "permission": "Permission",
    "yes": "Oui",
    "no": "Non",
    "items": {
      "confirmNegativeStock": {
        "title": "Confirmer un stock négatif",
        "text": "Valider même si une quantité passe sous zéro"
      },
      "quickTransfer": {
        "title": "Transfert rapide",
        "text": "Envoyer et réceptionner entre sites en une étape"
      },
      "approveLargeAdjustments": {
        "title": "Approuver les grosses corrections",
        "text": "Valider les ajustements au-delà du seuil"
      },
      "seeCosts": {
        "title": "Voir les coûts et les valeurs",
        "text": "Prix de revient, coût moyen et valeur du stock en TND"
      },
      "giveLargeDiscount": {
        "title": "Accorder de grosses remises",
        "text": "Remises au-delà de la limite fixée pour le comptoir"
      },
      "refundWithoutReceipt": {
        "title": "Rembourser sans ticket",
        "text": "Reprendre des articles quand la vente est introuvable"
      },
      "voidSale": {
        "title": "Annuler une vente",
        "text": "Annuler une vente payée d'une session ouverte"
      },
      "approveCashVariance": {
        "title": "Valider les écarts de caisse",
        "text": "Fermer une session dont l'écart de caisse dépasse la limite"
      },
      "openDrawer": {
        "title": "Ouvrir le tiroir-caisse",
        "text": "Ouvrir le tiroir sans vente"
      },
      "acceptLateReturn": {
        "title": "Accepter les retours tardifs",
        "text": "Reprendre des articles après le délai de retour"
      }
    }
  }
}
